import {
  PageHeader,
  Banner,
  Button,
  Badge,
  StatusBadge,
  Card,
  DetailPageTemplate,
  DetailSectionCard,
  DetailField,
  DetailFieldGrid,
} from "@/shared/ui";

export function ShellPlaceholder({ title }: { title: string }) {
  return (
    <div>
      <PageHeader title={title} subtitle="Chrome placeholder" />
    </div>
  );
}

export function UiGalleryPage() {
  return (
    <div className="space-y-4">
      <PageHeader
        title="UI Gallery"
        subtitle="Dev-only · ported DS from prototype"
        screenId="SCR-UI-GALLERY"
      />
      <Banner tone="info" title="Banner info" />
      <Banner tone="danger" title="Banner danger" />
      <Card className="flex flex-wrap gap-2">
        <Button>Primary</Button>
        <Button variant="secondary">Secondary</Button>
        <Button variant="ghost">Ghost</Button>
        <Button variant="soft">Soft</Button>
        <Button variant="danger">Danger</Button>
      </Card>
      <div className="flex flex-wrap gap-2">
        <Badge label="Badge" />
        <StatusBadge status="Active" />
        <StatusBadge status="Inactive" />
        <StatusBadge status="Passed" />
        <StatusBadge status="Failed" />
        <StatusBadge status="Hold" />
        <StatusBadge status="Quarantine" />
        <StatusBadge status="Available" />
      </div>

      <PageHeader title="DetailPageTemplate" subtitle="T1 smoke · tabs + sections" />
      <DetailPageTemplate
        notice={<Banner tone="info" title="Notice slot" />}
        status={
          <div className="flex flex-wrap items-center gap-2">
            <StatusBadge status="Draft" />
            <span className="text-caption text-text-secondary">Plant STVQ</span>
          </div>
        }
        defaultTabId="overview"
        tabs={[
          {
            id: "overview",
            label: "Tổng quan",
            content: (
              <DetailSectionCard title="Header">
                <DetailFieldGrid>
                  <DetailField label="Mã">SO-DEMO</DetailField>
                  <DetailField label="Trạng thái">Draft</DetailField>
                </DetailFieldGrid>
              </DetailSectionCard>
            ),
          },
          {
            id: "lines",
            label: "Dòng hàng",
            content: (
              <DetailSectionCard title="Lines">
                <p className="m-0 text-body text-text-secondary">Table slot</p>
              </DetailSectionCard>
            ),
          },
          {
            id: "documents",
            label: "Tài liệu",
            content: (
              <DetailSectionCard title="Tài liệu (T4b)">
                <p className="m-0 text-caption text-text-secondary">
                  Panel thật: EntityAttachmentsPanel trên SO detail.
                </p>
              </DetailSectionCard>
            ),
          },
          {
            id: "audit",
            label: "Audit",
            content: (
              <DetailSectionCard title="Audit (T4b)">
                <p className="m-0 text-caption text-text-secondary">
                  Panel thật: EntityAuditPanel trên SO detail.
                </p>
              </DetailSectionCard>
            ),
          },
        ]}
      />
    </div>
  );
}

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-2 bg-bg">
      <h1 className="text-page-title m-0">404</h1>
      <p className="m-0 text-body text-text-muted">Không tìm thấy trang</p>
    </div>
  );
}
